export const EMPLOYEE_COUNT_OPTIONS = [
  {
    id: "<10",
    label: "<10",
    value: "<10",
  },
  {
    id: "10-50",
    label: "10-50",
    value: "10-50",
  },
  {
    id: ">50",
    label: ">50",
    value: ">50",
  },
];

export const MARKET_AGE_OPTIONS = [
  {
    id: "<2",
    label: "<2",
    value: "<2",
  },
  {
    id: "2-5",
    label: "2-5",
    value: "2-5",
  },
  {
    id: ">5",
    label: ">5",
    value: ">5",
  },
];

export const CUSTOMER_COUNT_OPTIONS = [
  {
    id: "<1000",
    label: "<1000",
    value: "<1000",
  },
  {
    id: "'>1000",
    label: ">1000",
    value: ">1000",
  },
];

export const YES_NO_OPTIONS = [
  {
    id: "yes",
    label: "Yes",
    value: true,
  },
  {
    id: "no",
    label: "No",
    value: false,
  },
];
